export const checkDatesValidity = (
  startDate: string | undefined,
  endDate: string | undefined,
): boolean => {
  return !!startDate && !!endDate && startDate <= endDate;
};
